/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import * as authServices from "../../services/authService";
import { connect } from "react-redux";
import { SimpleLoginPage } from "../../configs/casinoShowList";
import { CaptchaAutoRefresh, CaptchaExpiryDeductionSec } from "../../configs/authSignupConfig";

let captchaCheckInterval = null;
class CaptchaComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      requestId: null,
      captchaImage: '',
      solution: '',
      expiryCaptcha: 0
    };
  }
  componentDidMount() {
    this.getCaptchaFn();
    // this.setState({captchaImage: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAAAAADm7SDXAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAD/h4/MvwAAAAd0SU1FB+gCAgsUHNDwzF8AAAM6SURBVHja7ZpLSFRhFMf/d7y+YsoGGwkKeilSQYqRFWKZZQUtAh8pLZIwkpAyqk2Yi2gjlIukjIi0bFdmUlQY6CafmOXGatFr0cNqYAiZLK/jaTGOM3cYx3svDB3q/Fb3ft85536/797vMItRCP8Gtr+9ABEREeaICDdEhBsiwg0R4YaIcENEuCEi3BARbogIN0SEGyLCDRHhhohw4/8VeV6ckrDq+CgAnFFmOBQxJzMQ2D5H+fZdyXFLSgcsmJA5HqlwZNqR/IKIagJVjkVMyggEPolcvgpIWhsPW4PJZRGZFPnswGmNxkqR5iXyfPdxDstcEbPc04FbUBa5fAuUei95jkB5GmWReuQQEXmS0DkzNpJoC3nsjcqBcMkXsfxH5PLrUElERDtRFGWRy3nXiIgoG9f9Q1PrcTQkqhy3wuS+TUBH5OouYJCIiJqRFmWRaX4vQpf/uhnO0H0OL1KEwqC7ysC52eofmxhq8xIRUQsyzS5JtdLq3NWurLzp6581qF1gJKn7bkzdHCGxWVkAgMlG7Ih21yKiKwV25H7y312Cczw0Iuwb2a0/6V5thsmQyMkyOL+YXZUFkXwAOf6vfSodZ4MnHwTt0VjwxGsFQ8bqTxRifp/pVVkQ+TD+6jBi7vluHiNR13pnFanCNoP1K7Cw3/yqrB12qsBK3wdRHtIopzRN0w7gpqZpWvC4NwXNusBwh52IiHoQH7Z5z4HF31qn8O49AHgfokQ3oaiqqiqwqaqq6yN932L3Givdiv3ZFlZkUsQ96AEApAKjANDrSthjKPE+tjt0A42Bw96pm3iDXAseMNl+14zeKQaAj8BiAOjGZruhxG4UhOzgbFu4IW61FRGTbyQfVwEADUhLBYBn2GgozztsMBCobd1kRcTkYR+OwYlfpNUpaCMiohW4bShvBPAYfETT+S6DkTrMdq0mFfYMB2wXfLdxMNZhOuA0+oR0VFsRMdu1DvaXzHsZv6/3JADAPYGlhtK+GoyzjiL/oGOGiHBDRLghItwQEW6ICDdEhBsiwg0R4YaIcENEuCEi3BARbogIN0SEGyLCDRHhhohwQ0S4ISLcEBFuiAg3RIQbIsINEeHGH8Nk+em/q75iAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTAyLTAyVDExOjIwOjI3KzAwOjAwPF5uoQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0wMi0wMlQxMToyMDoyNyswMDowME0D1h0AAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjQtMDItMDJUMTE6MjA6MjcrMDA6MDAaFvfCAAAAAElFTkSuQmCC"});
  }
  componentWillUnmount() {
    clearInterval(captchaCheckInterval);
  }
  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.updateParent();
    });
  }

  getCaptchaFn() {
    const self = this;
    this.setState({ loader: true }, () => {
      authServices.getCaptcha().then(async (result) => {
        // self.setState({buttonLoader: false});
        if (!!result && result.captchaImage) {
          self.setState({
            loader: false,
            requestId: result.requestId,
            captchaImage: "data:image/png;base64," + result.captchaImage,
            expiryCaptcha: (new Date().getTime() + ((result.expireSeconds - CaptchaExpiryDeductionSec) * 1000)),
            solution:''
          }, () => {
            self.updateParent();
            if(CaptchaAutoRefresh){
              self.setCaptchaInterval();
            }
          })
        } else {
          self.setState({ loader: false });
          // self.props.notify(result.exception.message, "error");
        }
      });
    });
  }

  setCaptchaInterval() {
    const self = this;
    captchaCheckInterval = setInterval(async function captchaCheckIntervalFn() {
      clearInterval(captchaCheckInterval);

      if (new Date().getTime() < self.state.expiryCaptcha) {
        captchaCheckInterval = setInterval(captchaCheckIntervalFn, 1000);
      } else {
        self.getCaptchaFn();
      }
    }, 1000)
  }

  updateParent() {
    this.props.updateCaptchaData(this.state.requestId, this.state.solution, this.state.expiryCaptcha);
  }

  refreshClick(){
    clearInterval(captchaCheckInterval);
    this.getCaptchaFn();
  }

  render() {
    return (
      <>
        {SimpleLoginPage ?
          <>

            <div className="align-items-md-center d-flex margin-bottom-5px w-100">
              <div className="captchabox1">
                <div className="captchabox-6-1">
                  <img src={this.state.captchaImage} alt="" />
                </div>
                <div className="captchabox-6-1 captcha-ref-box ">
                  <input
                    className="field p-relative form-control form-font-small"
                    type="text"
                    value={this.state.solution}
                    name="solution"
                    id="solution"
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    onKeyUp={(e) => {this.props.onKeyUp(e)}}
                    placeholder="Solve captcha"
                  />
                  <i id="iCaptchaRefresh" className="fa fa-refresh ml-1 text-success" onClick={() => this.refreshClick()}></i>
                </div>
              </div>
            </div>
          </>
          :

          <div className="align-items-md-center d-flex margin-bottom-5px">
            <div className="captchabox">
              <div className="captchabox-6">
                <img src={this.state.captchaImage} alt="" />
              </div>
              <div className="captchabox-6 captcha-ref-box">
                <input
                  className="field p-relative"
                  type="text"
                  value={this.state.solution}
                  name="solution"
                  id="solution"
                  onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, '');}}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  onKeyUp={(e) => {this.props.onKeyUp(e)}}
                  placeholder="Solve captcha"
                />
                <i id="iCaptchaRefresh" className="fa fa-refresh ml-1 text-success" onClick={() => this.refreshClick()}></i>
              </div>
            </div>


          </div>
        }
      </>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(CaptchaComp);
